@let uiStates = workspacesUI$ | async;
@let sidebarWorkspaces = sidebarWorkspaces$ | async;
@let advancedCommunitySidebar = (advancedCommunitySidebar$ | async) ?? false;
@let showDashboardLink = (showDashboardLink$ | async) ?? false;

<div class="flex size-full flex-col overflow-hidden" id="sidebar" tabindex="-1">
    @let activeSection = sectionSelected();
    <ul class="flex flex-col" role="list">
        @if (
            activeSection &&
            createButtonSections.includes(activeSection.sectionId)
        ) {
            @let label =
                activeSection | apply: createNewButtonLabel | translate;

            @if (activeSection.sectionId === 'i-lab') {
                <li class="create-new-button">
                    @if (expanded()) {
                        <button
                            interacta-button
                            type="button"
                            [attr.aria-haspopup]="'dialog'"
                            [disabled]="recorderService.isRecording()"
                            [icon]="'plus'"
                            [label]="label"
                            [style]="'filled'"
                            (click)="openILabSourcePicker()"
                        ></button>
                    } @else {
                        <button
                            interacta-icon-button
                            type="button"
                            [attr.aria-haspopup]="'dialog'"
                            [disabled]="recorderService.isRecording()"
                            [icon]="'plus'"
                            [label]="label"
                            [style]="'filled'"
                            (click)="openILabSourcePicker()"
                        ></button>
                    }
                </li>
            } @else {
                @if (label) {
                    <li>
                        <button
                            class="create-new-button"
                            interacta-responsive-button
                            type="button"
                            [breakpoint]="expanded() ? 'button' : 'icon-button'"
                            [disabled]="createNewDisabled()"
                            [icon]="'plus'"
                            [label]="label"
                            [style]="'filled'"
                            [tooltipPosition]="'right'"
                            (click)="handleCreateClick(selectedCommunity())"
                        ></button>
                    </li>
                }
            }
        }
        <!-- Sezione NON scrollabile, Home e Community -->
        @for (
            sidebarSection of sidebarNotScrollableSections;
            track sidebarSection.id
        ) {
            <li
                class="transition-transform duration-250"
                [attr.inert]="showAdvancedCommunityResearch() ? '' : null"
                [style.transform]="
                    'translateX(' +
                    (showAdvancedCommunityResearch() ? '-100%' : '0') +
                    ')'
                "
            >
                <interacta-sidebar-section
                    class="my-8"
                    [advancedSidebar]="
                        advancedCommunitySidebar &&
                        sidebarSection.id === 'community' &&
                        !showAdvancedCommunityResearch()
                    "
                    [advancedSidebarControlsId]="'advanced-community-research-panel'"
                    [advancedSidebarOpen]="showAdvancedCommunityResearch()"
                    [disabled]="
                        sidebarSection.id === 'community' &&
                        !advancedCommunitySidebar
                    "
                    [expanded]="expanded()"
                    [id]="
                        advancedCommunitySidebar &&
                        sidebarSection.id === 'community'
                            ? 'community'
                            : ''
                    "
                    [section]="sidebarSection"
                    [selected]="
                        sectionSelected()?.sectionId === sidebarSection.id
                    "
                    (toggleAdvancedSidebar)="
                        advancedCommunitySidebar &&
                            toggleAdvancedSidebar(
                                sidebarSection.id,
                                showAdvancedCommunityResearch()
                            )
                    "
                />
            </li>
        }
    </ul>

    <!-- contenitore della sezione scrollabile -->
    <div
        class="relative h-full w-252 grow overflow-y-auto"
        [attr.inert]="showAdvancedCommunityResearch() ? '' : null"
    >
        <div
            class="flex h-full flex-col transition-transform duration-250"
            [style.transform]="
                'translateX(' +
                (showAdvancedCommunityResearch() ? '-100%' : '0') +
                ')'
            "
        >
            <interacta-invisible-scroll class="min-h-0 grow">
                @if (!advancedCommunitySidebar && sidebarWorkspaces) {
                    <interacta-sidebar-workspace-list
                        [expanded]="expanded()"
                        [pinEnabled]="true"
                        [selectedCommunity]="selectedCommunity()"
                        [showDashboardLink]="showDashboardLink"
                        [uiStates]="uiStates ?? null"
                        [workspaceList]="sidebarWorkspaces"
                        (collapsedWs)="onCollapsedWs($event)"
                    />
                }

                <div class="flex flex-col overflow-x-hidden">
                    <ul class="flex flex-col" role="list">
                        @for (
                            sidebarSection of otherVisibleSidebarSections();
                            track sidebarSection.id
                        ) {
                            <li>
                                <interacta-sidebar-section
                                    [advancedSidebar]="
                                        advancedCommunitySidebar &&
                                        sidebarSection.id === 'community'
                                    "
                                    [expanded]="expanded()"
                                    [id]="sidebarSection.id"
                                    [section]="sidebarSection"
                                    [selected]="
                                        sectionSelected()?.sectionId ===
                                        sidebarSection.id
                                    "
                                    (toggleAdvancedSidebar)="
                                        toggleAdvancedSidebar(
                                            sidebarSection.id,
                                            sidebarSection.id === 'community'
                                                ? showAdvancedCommunityResearch()
                                                : false
                                        )
                                    "
                                />
                            </li>
                        }
                    </ul>
                    @if (aiEnabled()) {
                        @let label = 'AI.SIDEBAR_GUIDE_CENTER' | translate;
                        <button
                            class="relative my-16 ml-8 flex max-h-72 items-center rounded-xl bg-surface-B p-12 text-text-mid-contrast transition-all hover:text-text"
                            type="button"
                            [attr.aria-label]="expanded() ? undefined : label"
                            [matTooltip]="'SIDEBAR.GUIDE_CENTER' | translate"
                            [matTooltipDisabled]="expanded()"
                            [matTooltipPosition]="'right'"
                            [ngClass]="expanded() ? 'w-224' : 'w-48'"
                            (click)="openAIPanel()"
                        >
                            <p
                                class="line-clamp-3 overflow-hidden text-left typo-xs transition-all delay-150"
                                [ngClass]="
                                    expanded()
                                        ? 'w-full scale-100 opacity-100'
                                        : 'w-0 scale-0 text-nowrap opacity-0'
                                "
                            >
                                {{ label }}
                            </p>

                            <interacta-icon
                                [icon]="'book-open'"
                                [ngClass]="
                                    expanded()
                                        ? 'absolute -top-6 -right-6 size-20'
                                        : 'size-24'
                                "
                            />
                        </button>
                    }
                </div>
            </interacta-invisible-scroll>
        </div>
    </div>

    @if (!showAdvancedCommunityResearch()) {
        <interacta-sidebar-logo [currentTheme]="currentTheme()" />
    }

    <!-- TITOLO NON SCROLLABILE DEL SUBMENU COMMUNITY -->
    @if (showAdvancedCommunityResearch() && sidebarWorkspaces) {
        <div
            class="absolute top-116 flex w-252 grow flex-col transition-transform duration-250"
            [style.transform]="
                'translateX(' +
                (showAdvancedCommunityResearch() ? '0' : '100%') +
                ')'
            "
            (transitionend)="isAnimatingAdvancedTab.set(false)"
            (transitionstart)="isAnimatingAdvancedTab.set(true)"
        >
            <interacta-sidebar-section
                [expanded]="expanded()"
                [id]="'advancedCommunityResearch'"
                [section]="communityAdvancedSection"
                [selected]="true"
                (toggleAdvancedSidebar)="
                    toggleAdvancedCommunityResearchAndSwitchFocus(
                        showAdvancedCommunityResearch()
                    )
                "
            />
        </div>
    }

    <!-- SUBMENU DELLE COMMUNITY -->
    <div
        class="absolute top-168 flex w-252 grow flex-col overflow-y-auto transition-transform duration-250"
        id="advanced-community-research-panel"
        [attr.inert]="!showAdvancedCommunityResearch() ? '' : null"
        [ngClass]="{ 'h-[calc(100%-11rem)]': showAdvancedCommunityResearch() }"
        [style.transform]="
            'translateX(' +
            (showAdvancedCommunityResearch() ? '0' : '100%') +
            ')'
        "
        (transitionend)="isAnimatingAdvancedTab.set(false)"
        (transitionstart)="isAnimatingAdvancedTab.set(true)"
    >
        <interacta-invisible-scroll>
            @if (sidebarWorkspaces) {
                <interacta-sidebar-advanced-community-research
                    class="bg-surface-A"
                    [expanded]="expanded()"
                    [hidden]="
                        !showAdvancedCommunityResearch() &&
                        !isAnimatingAdvancedTab()
                    "
                    [selectedCommunity]="selectedCommunity()"
                    [showDashboardLink]="showDashboardLink"
                    [uiStates]="uiStates ?? null"
                    [workspaces]="sidebarWorkspaces"
                    (collapsedWs)="onCollapsedWs($event)"
                />
            }
        </interacta-invisible-scroll>
    </div>
</div>

@if (showCommunitySelectionDialog(); as showCommunitySelectionDialog) {
    <interacta-community-selection-dialog
        [isOpen]="showCommunitySelectionDialog.isOpen"
        [recentCommunities]="recentCommunities()"
        [workspaces]="(operativityWorkspaces$ | async) ?? []"
        (closeDialog)="showCommunitySelectionDialog.callback(null)"
        (selectedCommunity)="showCommunitySelectionDialog.callback($event)"
    />
}
